import {z as zod} from "zod";

export type OttopilotContestsWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotContestsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotContestsWorkspaceCapabilityConfiguration> = zod.strictObject({});
